import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function studentGuidanceReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_LOADING:
    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_FAILURE:
    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.studentGuidanceProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ studentGuidance: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { studentGuidance: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.studentGuidance.id === action.id);
      if (index !== -1) newList.splice(index, 1, { studentGuidance: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.studentGuidance.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1, { studentGuidance: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.studentGuidance.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.studentGuidance.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.studentGuidance.id === action.id);
      if (index !== -1) newList.splice(index, 1, { studentGuidance: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.studentGuidance.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1, { studentGuidance: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetchingAccepted: false,
      });
    }

    default:
      return state;
  }
}

